export { CustomerSelector } from './src/customer-selector';
export { DummyCustomerSelector } from './src/dummy-customer-selector';
